import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {
    address,
    blockSpecialCharachters,
    city,
    dose_input,
    GOOGLE_RECAPTCHA_SITE_KEY,
    name_input,
    number_input,
    phoneNumber,
    roles,
    textareaBox,
    zipCode
} from 'src/app/constant/constant';
import {
    ApiResult,
    ErrorModel,
    PromiseResult,
    ServerError
} from 'src/app/models/PromiseResult';
import { ForgotPasswordData } from 'src/app/models/User';
import { UserService } from 'src/app/services/user.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { TraceClassDecorator } from '@sentry/angular';
import { CountriesService } from '../../../services/countries.service';
import { OtpInputComponent } from '../../shared/otp-input/otp-input.component';
import { GeocoderResponse } from 'src/app/models/util.models';
import { GeocodingService } from 'src/app/services/geeocoding.google.service';
import { CountrySelectedValue } from 'src/app/models/doctorregistration';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
    selector: 'app-forget-password-patient',
    templateUrl: './forget-password-patient.component.html',
    styleUrls: [
        './forget-password-patient.component.css',
        './../login-home/login-home.component.css'
    ]
})
@TraceClassDecorator()
export class ForgetPasswordPatientComponent implements OnInit {

    @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;

    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
    readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
    formPosting: boolean = false;
    isPassword: boolean = true;
    forgotPasswordDone = false;
    slug: string = "";
    forgot_password = new ForgotPasswordData();
    // result: PromiseResult;
    logo_url: string = '';
    provider_id: string = "";
    response: PromiseResult = new PromiseResult();
    error: ErrorModel = new ErrorModel();
    serverError: ServerError = new ServerError();

    constructor(
        private readonly userservice: UserService,
        private readonly utilitiesService: UtilitiesService,
        private readonly country: CountriesService,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly geocodingService: GeocodingService,
        private providerStateService: ProviderStateService
    ) {
        this.forgot_password.body.role = roles.patient;
        this.forgot_password.tokenBody.role = roles.patient;
    }


    async ngOnInit(): Promise<void> {
        this.slug = this.providerStateService.getProviderSlug();
        this.reset_variables();
        this.provider_id = this.providerStateService.getProviderId();
        this.forgot_password.userid_data.setCurrentType(false);
        this.forgot_password.recaptchaData.reset();
        await this.getCountries();
        await this.getCurrentLocation();
        this.logo_url = this.providerStateService.getLogoUrl();
    }


    resolved(captchaResponse: string) {
        this.forgot_password.body.recaptcha = captchaResponse;
    }

    reset_variables(): void {
        // this.registrationDone = false;
        // this.isPassword_Login = true;
        this.isPassword = true;
        // this.forgotEmailDone = false;
        this.forgotPasswordDone = false;
        // this.forgotDoctorPasswordDone = false;
        // this.forgotDoctorEmailDone = false;
        // this.resendDone = false;
        // this.loginDone = false;
        // this.authresult = { authtoken: "", userid: "", name: "", rememberme: false, userrole: [] }
        this.response = new PromiseResult();
        sessionStorage.clear();
    }

    async patientForgotPasswordSubmit() {
        this.formPosting = true;
        //    await grecaptcha.reset();
        await this.patientForgotPassword();
    }
    async getCountries(): Promise<void> {
        await this.country
          .getCountries(this.provider_id)
          .toPromise()
          .then(async (countries) => {
            countries.forEach((ele) => {
              ele["final_value"] = ele.acronym,
                ele["final_label_string"] = ele.acronym + " (" + '+' + String(ele.phone_code) + ")";
              let country_data: CountrySelectedValue = {
                id: Number(ele.id),
                acronym: ele.acronym,
                is_national_license: ele.is_national_license,
                phone_code: '+' + String(ele.phone_code),
                country_name: ele.country_name
              };
              this.forgot_password.userid_data.countries_code_3[ele.acronym] = country_data;
              this.forgot_password.userid_data.countries_code_2[ele.iso_3166_1_aplha_2] = country_data;
            });
            this.forgot_password.userid_data.country_codes = this.utilitiesService.getSelectItemList(countries, "final_label_string", "final_value");
          }).catch((err) => {
            console.error(err);
          });
      }

      setCountry(country_code: string) {
        if (country_code in this.forgot_password.userid_data.countries_code_2) {
            this.forgot_password.userid_data.selected_country_data = this.forgot_password.userid_data.countries_code_2[country_code];
            this.forgot_password.userid_data.selected_country_acronym = this.forgot_password.userid_data.selected_country_data.acronym;
        }
    }

    async getCurrentLocation() {
        let location_api_result: GeocoderResponse = new GeocoderResponse("", []);
        let user_country: string = localStorage.getItem("user_country");
        if (user_country != null) {
            this.setCountry(user_country);
        }
        else {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const point: google.maps.LatLngLiteral = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };

                    await this.geocodingService.geocodeLatLng(point)
                        .then((response: GeocoderResponse) => {
                            if (response.status === 'OK' && response.data?.length) {
                                let country_code = null;
                                response.data.forEach(element => {
                                    if (element.types.includes('country')) {
                                        // Find the country code in the address components
                                        const countryCodeComponent = element.address_components.find(component => component.types.includes('country'));
                                        if (countryCodeComponent) {
                                            // Extract the country code from the address component
                                            country_code = countryCodeComponent.short_name;
                                        }
                                    }
                                });

                                // Set the country code
                                this.setCountry(country_code);

                                // Save the country code in localStorage if needed
                                localStorage.setItem("user_country", country_code);
                            } else {
                                location_api_result.success = false;
                                location_api_result = response
                                return location_api_result;
                            }
                        })
                },
                (error) => {
                    location_api_result.error.message = "Couldn't get your location";
                    location_api_result.success = false;
                    if (error.PERMISSION_DENIED) {
                        location_api_result.error.code = 'PERMISSION_DENIED';
                    } else if (error.POSITION_UNAVAILABLE) {
                        location_api_result.error.code = 'POSITION_UNAVAILABLE';
                    } else if (error.TIMEOUT) {
                        location_api_result.error.code = 'POSITION_TIMEOUT';
                    } else {
                        location_api_result.error.code = "UNKNOWN-" + error.code;
                        location_api_result.error.message = error.message;
                    }
                    return location_api_result;
                },
                { enableHighAccuracy: true }
            );
        }
    }


    async userIdFormSubmit() {
        if (this.forgot_password.userid_data.isPhoneNumber()) {
            this.forgot_password.userid_data.selected_country_data = this.forgot_password.userid_data.countries_code_3[this.forgot_password.userid_data.selected_country_acronym];
            this.forgot_password.userid_data.contact_number = this.forgot_password.userid_data.selected_country_data.phone_code + this.forgot_password.userid_data.userid_value;
            this.forgot_password.body.userid = this.forgot_password.userid_data.contact_number;
        }
        else {
            this.forgot_password.userid_data.email = this.forgot_password.userid_data.userid_value;
            this.forgot_password.body.userid = this.forgot_password.userid_data.userid_value;
        }
        await this.patientForgotPassword();

    }
    async patientForgotPassword(): Promise<void> {
        this.forgot_password.forgot_api_result = new ApiResult(true);
        await this.userservice
            .forgotPassword(this.forgot_password.body)
            .toPromise()
            .then((result) => {
                this.forgot_password.forgot_api_result.PromiseResult = result;
                if (result.success) {
                    this.forgot_password.tokenBody.user_guid = result.data.user_guid;
                    this.set_otp_data(result);
                    this.forgot_password.tabViewData.nextTab(1);
                }
                this.forgot_password.otp_data.otp_api_result.Posting = false;
                this.forgot_password.forgot_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.forgot_password.otp_data.otp_api_result.ServerError = error.error;
                this.forgot_password.otp_data.otp_api_result.PromiseResult.success = false;
                this.forgot_password.otp_data.otp_api_result.Posting = false;
            })
    }

    openLink(
        base_url_name: string,
        link: string,
        target: string
    ): void {
        this.utilitiesService.openWebsiteLinks(
            base_url_name,
            link,
            target
        );
    }

    async login_validate_or_resend_otp() {
        this.forgot_password.tokenBody.token = this.forgot_password.otp_data.OTP_validate_api.token;
        this.forgot_password.otp_data.otp_api_result = new ApiResult(true);
        await this.userservice
            .validateForgotPasswordToken(this.forgot_password.tokenBody)
            .toPromise()
            .then(result => {
                this.forgot_password.otp_data.otp_api_result.PromiseResult = result;
                if (result.success) {
                    if (this.forgot_password.tokenBody.retry) {
                        this.set_otp_data(result);
                        this.changeDetector.detectChanges();
                        this.OTP_Input.init_countdown();
                    }
                    else this.forgot_password.tabViewData.nextTab(2);
                }
                this.forgot_password.otp_data.otp_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.forgot_password.otp_data.otp_api_result.ServerError = error.error;
                this.forgot_password.otp_data.otp_api_result.PromiseResult.success = false;
                this.forgot_password.otp_data.otp_api_result.Posting = false;
            })
    }

    set_otp_data(result: PromiseResult) {
        this.forgot_password.otp_data.OTP_validate_api.service_id = result.data.service_id;
        this.forgot_password.tokenBody.service_id = result.data.service_id;
        this.forgot_password.otp_data.OTP_validate_api.retry_after = new Date(result.data.retry_after);
    }

    async otp_resend() {
        this.forgot_password.tokenBody.retry = true;
        await this.login_validate_or_resend_otp();
    }


    async otpVerifySubmit() {
        this.forgot_password.tokenBody.retry = false;
        await this.login_validate_or_resend_otp();

    }

    isPosting(): boolean {
        return this.forgot_password.forgot_api_result.Posting ||
            this.forgot_password.otp_data.otp_api_result.Posting;
    }
}
